import util from '../../common/util';
import comingSoon from './index.vue';

import { h } from 'vue';

export default function getComingSoon(globalData, moduleData) {
    let isSkipCheckPage = [
        'sold-compliance-check',
        'active-compliance-check',
    ].includes(globalData.pageKey);

    if (isSkipCheckPage) {
        this.setCookie('hide_comingsoon_compliance', 1, 0.1)
    }
    let hasHide = this.getCookie('hide_comingsoon') || util.inIframePreview;
    let hasHideTemp = this.getCookie('hide_comingsoon_compliance');

    let hideFromUrl = this.pageLocation?.query?.hideComingsoon == 1;
    

    let notPendingSite = globalData?.websiteInfo?.status !== 0;
    let isLandingPage = globalData.isLandingPage;
    if (
        isSkipCheckPage || 
        util.inCms || 
        hasHide || 
        hasHideTemp ||
        notPendingSite ||
        util.isScreenshot ||
        isLandingPage || 
        hideFromUrl
    ) {
        return;
    } else {
        return h(comingSoon, {
            globalData: globalData,
            modules: moduleData
        });
    }
    
}